import { Descriptions, InputNumber, Form, Input } from "antd";
import { ButtonUi } from "../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../types/typesConstants";
import { useSelector } from "react-redux";
import { parseNumeric } from "../../../../helpers/utils";
import { fn_CalculoTotales_Item } from "../../../../helpers/functions";
import { messageError } from "../../../../helpers";
import { TwoDecimalInput } from "../../../ui";
const Style_ItemDescription = {
  paddingBottom: "2px",
  paddingInlineEnd: "4px",
};
const Style_Input = {
  fontSize: "11px",
  marginBottom: "0px",
};
export const PosCarritoContentItem = ({ field, handleRemove }) => {
  const form = Form.useFormInstance();
  const { activeEmpleado } = useSelector((state) => state.auth);
  const { setFieldValue, getFieldValue } = form;
  const { manejalotes, manejaseries } = getFieldValue([
    "detallecomprobante",
    field.name,
  ]);
  const readOnlyFieldLotesOrSeries = !manejalotes && !manejaseries;
  const detallecomprobante = Form.useWatch("detallecomprobante", form);
  const onChangeCantidad = (value, field) => {
    const item = detallecomprobante[field?.name];
    // Validar cantidad con el stock disponible
    if (item?.stockactual < value) {
      value = item?.stockactual; // Ajustar el valor al stock disponible
      setFieldValue(
        ["detallecomprobante", field.name, "cantidad"],
        item?.stockactual,
      );
      messageError("La cantidad no puede ser mayor al stock disponible");
    }
    const porcentajeigv = parseNumeric(activeEmpleado?.empresa?.porcentajeigv);
    const {
      valorunitario,
      valorigvunitario,
      valorigv,
      valorventabruto,
      valorventa,
      totalventa,
    } = fn_CalculoTotales_Item({
      preciounitario: item?.preciounitario,
      cantidad: value,
      descuentos: item?.descuentos,
      porcentajeigv,
    });
    setFieldValue(
      ["detallecomprobante", field.name, "valorunitario"],
      valorunitario,
    );
    setFieldValue(
      ["detallecomprobante", field.name, "valorigvunitario"],
      valorigvunitario,
    );
    setFieldValue(["detallecomprobante", field.name, "valorigv"], valorigv);
    setFieldValue(
      ["detallecomprobante", field.name, "valorventabruto"],
      valorventabruto,
    );
    setFieldValue(["detallecomprobante", field.name, "valorventa"], valorventa);
    setFieldValue(["detallecomprobante", field.name, "totalventa"], totalventa);
  };
  const OnChangePrecioVenta = (e, field) => {
    const item = detallecomprobante[field.name];
    const porcentajeigv = parseNumeric(activeEmpleado?.empresa?.porcentajeigv);
    const {
      valorunitario,
      valorigvunitario,
      valorigv,
      valorventabruto,
      valorventa,
      totalventa,
    } = fn_CalculoTotales_Item({
      preciounitario: e,
      cantidad: item?.cantidad,
      descuentos: item?.descuentos,
      porcentajeigv,
    });
    setFieldValue(
      ["detallecomprobante", field.name, "valorunitario"],
      valorunitario,
    );
    setFieldValue(
      ["detallecomprobante", field.name, "valorigvunitario"],
      valorigvunitario,
    );
    setFieldValue(["detallecomprobante", field.name, "valorigv"], valorigv);
    setFieldValue(
      ["detallecomprobante", field.name, "valorventabruto"],
      valorventabruto,
    );
    setFieldValue(["detallecomprobante", field.name, "valorventa"], valorventa);
    setFieldValue(["detallecomprobante", field.name, "totalventa"], totalventa);
  };

  return (
    <>
      <Descriptions column={{ xs: 1, sm: 2, md: 3, lg: 6, xl: 6, xxl: 6 }}>
        <Descriptions.Item
          style={{ ...Style_ItemDescription, width: "10%" }}
          className="poscarritocontent__item"
          key="unidadmedida"
        >
          <Form.Item
            {...field}
            name={[field.name, "prefijounidadmedida"]}
            style={{ marginBottom: 0 }}
          >
            <Input
              size="small"
              variant="borderless"
              readOnly={true}
              style={Style_Input}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item
          style={{ ...Style_ItemDescription, width: "15%" }}
          className="poscarritocontent__item"
          key="cantidad"
        >
          <Form.Item
            {...field}
            name={[field.name, "cantidad"]}
            rules={[
              { required: true, message: "La cantidad es obligatoria" },
              {
                type: "number",
                message: "Ingrese un número",
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <InputNumber
              size="small"
              style={{ fontSize: "11px", marginBottom: "0px", width: "90%" }}
              onChange={(value) => onChangeCantidad(value, field)}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault(); // Bloquea el submit
              }}
              min={1}
              precision={2}
              readOnly={!readOnlyFieldLotesOrSeries}
              variant={readOnlyFieldLotesOrSeries ? "outlined" : "borderless"}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item
          style={{ ...Style_ItemDescription, width: "35%" }}
          styles={{ content: { width: "100%", display: "inline" } }}
          className="poscarritocontent__item"
          key="nombre"
        >
          <Form.Item
            {...field}
            name={[field.name, "nombre"]}
            style={{ marginBottom: 0 }}
          >
            <Input
              size="small"
              variant="borderless"
              readOnly={true}
              style={{ fontSize: "8px", fontWeight: "bold" }}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item
          style={{ ...Style_ItemDescription, width: "15%" }}
          className="poscarritocontent__item"
          key="preciounitario"
        >
          <Form.Item
            {...field}
            name={[field.name, "preciounitario"]}
            rules={[
              { required: true, message: "El precio de venta es obligatorio" },
              {
                type: "number",
                message: "Ingrese un número",
              },
            ]}
          >
            <TwoDecimalInput
              size="small"
              style={{ ...Style_Input, width: "90%" }}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault(); // Bloquea el submit
              }}
              onChange={(value) => OnChangePrecioVenta(value, field)}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item
          style={{ ...Style_ItemDescription, width: "15%" }}
          className="poscarritocontent__item"
          key="totalventa"
        >
          <Form.Item
            {...field}
            name={[field.name, "totalventa"]}
            rules={[
              { required: true, message: "El total es obligatorio" },
              {
                type: "number",
                message: "Ingrese un número",
              },
            ]}
          >
            <InputNumber
              size="small"
              variant="borderless"
              readOnly={true}
              precision={2}
              style={{
                ...Style_Input,
                width: "100%",
                textAlignLast: "right",
                fontWeight: "bold",
              }}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item
          style={{
            paddingBottom: "2px",
            paddingTop: "5px",
            paddingLeft: "5px",
          }}
          className="poscarritocontent__item"
          key="acciones"
        >
          <ButtonUi
            typeUi={TipoButtonConstants.EliminarTable}
            displayText={false}
            onClick={() => handleRemove(field.name)}
            size="small"
          />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};
